import { MedqContentProviderClient } from '../services/contents/medq-content-provider.client';

const contentProviderClient = new MedqContentProviderClient({
  endpoint: process.env.REACT_APP_CONTENT_PROVIDER_API_URL as string,
});

export default contentProviderClient;
